"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.applySearch = exports.countData = exports.filterData = exports.applyAlternateToggles = exports.applySwitches = exports.deriveUniqueValues = exports.getUseName = exports.isUselessValue = exports.calculateStats = exports.stdDevationOf = exports.avgOf = void 0;

var avgOf = function avgOf(vals) {
  if (vals.length === 0) {
    return 0;
  }

  return vals.reduce(function (acc, val) {
    return acc + val;
  }, 0) / vals.length;
};

exports.avgOf = avgOf;

var stdDevationOf = function stdDevationOf(vals) {
  if (vals.length === 0 || vals.length === 1) {
    return 0;
  }

  var m = avgOf(vals);
  return Math.sqrt(vals.reduce(function (sq, val) {
    return sq + Math.pow(val - m, 2);
  }, 0) / (vals.length - 1));
};

exports.stdDevationOf = stdDevationOf;

var calculateStats = function calculateStats(data, stats) {
  if (stats) {
    return stats.reduce(function (acc, stat) {
      var valueSet = data.map(function (obj) {
        if (stat.extractorFn) {
          return stat.extractorFn(obj);
        } else {
          // default case, must be numeric or sad days ahead
          // if it has fieldName that overrules the name
          var useName = getUseName(stat);
          return obj[useName];
        }
      });
      acc[stat.name] = {
        average: avgOf(valueSet),
        standardDeviation: stdDevationOf(valueSet)
      };
      return acc;
    }, {});
  } else {
    return {};
  }
};

exports.calculateStats = calculateStats;

var isUselessValue = function isUselessValue(val) {
  return val === null || val === undefined || val === '' || Number.isNaN(val);
};

exports.isUselessValue = isUselessValue;

var getUseName = function getUseName(filter) {
  return filter.fieldName ? filter.fieldName : filter.name;
};

exports.getUseName = getUseName;

var deriveUniqueValues = function deriveUniqueValues() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var filter = arguments.length > 1 ? arguments[1] : undefined;
  return data.reduce(function (acc, obj) {
    var useName = getUseName(filter);
    var defaultValue = filter.defaultValue;

    if (filter && filter.type === 'custom' && filter.extractorFn) {
      var extracted = filter.extractorFn(obj[useName]);

      if (defaultValue && isUselessValue(extracted)) {
        extracted = defaultValue;
      }

      if (!acc.includes(extracted)) {
        acc.push(extracted);
      }
    } else if (Array.isArray(obj[useName])) {
      var opts = obj[useName].length === 0 && defaultValue ? [defaultValue] : obj[useName];
      opts.forEach(function (x) {
        var extracted = filter.extractorFn ? filter.extractorFn(x) : x;

        if (defaultValue && isUselessValue(extracted)) {
          extracted = defaultValue;
        }

        if (!acc.includes(extracted)) {
          acc.push(extracted);
        }
      });
    } else {
      var _extracted = obj[useName];

      if (defaultValue && isUselessValue(_extracted)) {
        _extracted = defaultValue;
      }

      if (!acc.includes(_extracted)) {
        acc.push(_extracted);
      }
    }

    return acc;
  }, []);
};

exports.deriveUniqueValues = deriveUniqueValues;

var applySwitches = function applySwitches(data, switches, checked) {
  return switches.reduce(function (data, s) {
    if (checked[s.name]) {
      return data.filter(s.extractorFn);
    } else {
      return data;
    }
  }, data);
};

exports.applySwitches = applySwitches;

var applyAlternateToggles = function applyAlternateToggles(data, toggles, toggled) {
  var relevantToggles = toggles.filter(function (t) {
    return toggled[t.name];
  });

  if (relevantToggles.length === 0) {
    // default to show ALL if NONE clicked
    return data;
  } else {
    return data.filter(function (d) {
      return relevantToggles.map(function (t) {
        return t.extractorFn(d);
      }).includes(true);
    });
  }
};

exports.applyAlternateToggles = applyAlternateToggles;

var filterData = function filterData(data, filters, checked) {
  return filters.reduce(function (data, filter) {
    var useName = getUseName(filter);
    var defaultValue = filter.defaultValue; // by default unchecked === 'all true'

    if (checked[filter.name].length > 0) {
      if (filter.type === 'custom' && filter.extractorFn) {
        return data.filter(function (obj) {
          var extracted = filter.extractorFn(obj[useName]);

          if (defaultValue && isUselessValue(extracted)) {
            extracted = defaultValue;
          }

          return checked[filter.name].includes(extracted);
        });
      } else if (filter.type === 'valueInSet') {
        return data.filter( // attempt to intersect an array value against some set of checked options
        function (obj) {
          return (obj[useName] || []).filter(function (value) {
            var extracted = filter.extractorFn ? filter.extractorFn(value) : value;

            if (defaultValue && isUselessValue(extracted)) {
              extracted = defaultValue;
            }

            return checked[filter.name].includes(extracted);
          }).length > 0;
        });
      } else {
        return data.filter(function (obj) {
          var extracted = obj[useName];

          if (defaultValue && isUselessValue(extracted)) {
            extracted = defaultValue;
          }

          return checked[filter.name].includes(extracted);
        });
      }
    } else {
      return data;
    }
  }, data);
}; // forgive me padre for i have sinned, there must be a better way :)


exports.filterData = filterData;

var countData = function countData(filteredData, data, filters) {
  return filters.reduce(function (counts, filter) {
    var useName = getUseName(filter);
    var defaultValue = filter.defaultValue;
    var uniqueValues = deriveUniqueValues(data, filter);
    counts[filter.name] = counts[filter.name] || {};
    uniqueValues.forEach(function (value) {
      counts[filter.name][value] = counts[filter.name][value] || 0;

      if (filter.type === 'custom' && filter.extractorFn) {
        counts[filter.name][value] += filteredData.filter(function (obj) {
          var extracted = filter.extractorFn(obj[useName]);

          if (defaultValue && isUselessValue(extracted)) {
            extracted = defaultValue;
          }

          return value === extracted;
        }).length;
      } else if (filter.type === 'valueInSet') {
        var filteredSubset = filteredData.filter(function (obj) {
          if (filter.extractorFn) {
            return (obj[useName] || []).map(function (rawVal) {
              var extracted = filter.extractorFn(rawVal);

              if (defaultValue && isUselessValue(extracted)) {
                extracted = defaultValue;
              }

              return extracted;
            }).includes(value);
          } else {
            return (obj[useName] || []).map(function (x) {
              if (defaultValue && isUselessValue(x)) {
                return defaultValue;
              } else {
                return x;
              }
            }).includes(value);
          }
        });
        counts[filter.name][value] += filteredSubset.length;
      } else {
        counts[filter.name][value] += filteredData.filter(function (obj) {
          var extracted = obj[useName];

          if (defaultValue && isUselessValue(extracted)) {
            extracted = defaultValue;
          }

          return extracted === value;
        }).length;
      }
    });
    return counts;
  }, {
    total: filteredData.length
  });
};

exports.countData = countData;

var applySearch = function applySearch(searchString, searchFilterFn, data) {
  if (!searchString || !searchFilterFn || searchString === '' || data === []) {
    return data;
  } else {
    return data.filter(function (item) {
      return searchFilterFn(item, searchString.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&'));
    });
  }
};

exports.applySearch = applySearch;